module.exports = __webpack_public_path__ + "static/img/top-bg.8facb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/top-bg.png
// module id = ZzwB
// module chunks = 1